import { render } from "./OrderHistory.vue?vue&type=template&id=7303bb84&ts=true"
import script from "./OrderHistory.vue?vue&type=script&lang=ts"
export * from "./OrderHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__